import React, { useEffect, useState } from "react";
import Modal from "../../../ReusableComponents/Modal";
import LoaderComponent from "../../../ReusableComponents/LoaderComponent";
import DateTimePicker from "../../../ReusableComponents/DateTimePicker";
import {
  GLOBAL_STYLES,
  STATUS,
  AEROMEGH_SERVICES,
  PAYMENT_METHODS,
  PAYMENT_STATUSES,
  INDIAN_STATES,
} from "../../../appConstants";
import { Button } from "../../../Components/Helper";
import Tippy from "@tippyjs/react";
import CloseIcon from "../../../assets/cancelIcon.svg";
import Filter from "../../../assets/filter.svg";
import { reduceLongName } from "../../../ReusableFunctions/reusableFunctions";
import SingleFilter from "../../../features/MyRequests/SubComponents/FilterRequest/SingleFilter";
import CustomTooltip from "../../../ReusableComponents/CustomTooltip";
import Popup from "../../../ReusableFunctions/Popup";
import { getAllDSPs } from "../../../apis/adminAPIs/dsp";
import dateFormat from "dateformat";
import { IsBhuMeetCouponApplied, PaymentMethodRadioButtons } from ".";
import DurationFilters from "../../../features/Revenue/SubComponents/DurationFilters";
import '../../../features/Revenue/SubComponents/DurationsFilters.css'
import filterIcon from '../../../assets/filterIcon.svg';
const AdminFilterRequest = ({
  open,
  isHideDSPFilter,
  onClose,
  onFilterChange,
  setOpenFilter,
  filters,
  screenWidth,
  loading,
  isFromUserDetails,
  activeTab
}) => {
  const [tempFilters, setTempFilters] = useState(filters);
  const [isScrollable, setIsScrollable] = useState(false);
  const [searchState, setSearchState] = useState("");
  const [searchDsp, setSearchDsp] = useState("")
  const [dsps, setDsps] = useState([]);
  const [formattedDate, setFormattedDate] = useState('');
  const [appliedFilters, setAppliedFilters] = useState();
  const [chipInputSize, setChipInputSize] = useState(0);
  const durationOptions = [
    { id: 6, placeholder: "All", interval: "all" },
    { id: 1, placeholder: "Today", interval: "day" },
    { id: 2, placeholder: "This Week", interval: "week" },
    { id: 3, placeholder: "This Month", interval: "month" },
    { id: 4, placeholder: "This Year", interval: "year" },
    {
      id: 5,
      placeholder: "Custom",
      interval: "custom",
      cb: () => {
        setOpenFilter(true);
      },
    },

  ];
  const handleOnChangeStatus = (e) => {
    const value = e.target.value;
    let newStatuses = tempFilters.statuses;
    if (e.target.checked) {
      if (newStatuses.length < 3) {
        newStatuses = [...newStatuses, value];
      } else {
        Popup.alert("WARNING", 'You can only select up to 3 status at time', 'ERROR')
        return;
      }
    } else {
      newStatuses = newStatuses.filter((status) => status !== value);
    }
    newStatuses = Array.from(new Set(newStatuses));
    setTempFilters((prev) => ({
      ...prev,
      statuses: newStatuses,
      isFilterByServiceTime:
        newStatuses?.length > 0 ? false : prev.isFilterByServiceTime,
    }));
  };

  const handleOnChangeState = (e) => {
    const value = e.target.value;
    let newStates = tempFilters.states;
    if (e.target.checked) {
      if (newStates.length < 3) {
        newStates = [...newStates, value];
      } else {
        Popup.alert("WARNING", 'You can only select up to 3 states at time', 'ERROR')
        return;
      }
    } else {
      newStates = newStates.filter((status) => status !== value);
    }
    newStates = Array.from(new Set(newStates));
    setTempFilters((prev) => ({
      ...prev,
      states: newStates
    }));
  };

  const handleOnChangeLocation = (e) => {
    const value = e.target.value;
    let dsps = tempFilters.dsps;
    if (e.target.checked) {
      if (dsps.length < 5) {
        dsps = [...tempFilters.dsps, value];
      } else {
        Popup.alert("WARNING", 'You can only select up to 5 dsp at time', 'ERROR')
        return;
      }
    } else dsps = dsps.filter((dsp) => dsp !== value);
    dsps = Array.from(new Set(dsps));
    setTempFilters((prev) => ({ ...prev, dsps: dsps }));
  };

  const getDspsFunc = async () => {
    try {
      const data = await getAllDSPs();
      let updatedDsps = [];
      updatedDsps = data.dsps.filter((d) => d.dsp_is_active);
      updatedDsps = updatedDsps?.sort((a, b) => {
        const firstNameA = a.dsp_name?.split(" ")[0].toLowerCase();
        const firstNameB = b.dsp_name?.split(" ")[0].toLowerCase();
        return firstNameA ? firstNameA.localeCompare(firstNameB) : -1;
      })
      setDsps(updatedDsps);
    } catch (err) {
      Popup.alert("Error", err, "ERROR");
    }
  };

  const clearFilter = async (filter) => {
    switch (filter.type) {
      case "service":
        if (filter.services.length !== 0) {
          onFilterChange({
            services: filters?.services?.filter((s) => s != filter?.name),
          });
        }
        break;
      case "status":
        if (filters.statuses.length !== 0) {
          onFilterChange({
            statuses: filters?.statuses?.filter((s) => s != filter?.name),
            paymentMethods:
              filter.name === PAYMENT_STATUSES.PAID
                ? null
                : filters.paymentMethods,
          });
        }
        break;
      case "dsp":
        if (dsps.length !== 0) {
          const { dsp_id } = dsps?.find(
            (dsp) => dsp?.dsp_name === filter?.name
          );
          onFilterChange({
            dsps: filters?.dsps?.filter((id) => id != dsp_id),
          });
        }
        break;
      case "state":
        onFilterChange({
          states: filters?.states?.filter((state) => filter.name != state),
        });
        break;
      case "date":
        onFilterChange({
          fromDate: null,
          toDate: null,
          isFilterByServiceTime: false,
          isFilterByDateCreated: false,
          interval: "all",
        });
        break;
      case "paymentMethods":
        onFilterChange({
          paymentMethods: null,
        });
        break;
      case "onlyAppliedBhuMeetCouponsRequests":
        onFilterChange({
          onlyAppliedBhuMeetCouponsRequests: false,
        });
        break;
      case "isFilterByServiceTime":
        onFilterChange({
          isFilterByServiceTime: false,
        });
        break;
      case "isFilterByDateCreated":
        onFilterChange({
          isFilterByDateCreated: false,
        });
        break;
      default:
        break;
    }
  };

  const getDateLabelfromFromDateAndToDate = (interval, fromDate, toDate) => {
    switch (interval) {
      case 'day':
        return `${dateFormat(fromDate, "dd/mm/yyyy")}`;
      case "week":
        return `${dateFormat(fromDate, "dd/mm/yyyy")} - ${dateFormat(toDate, "dd/mm/yyyy")}`;
      case "month":
        return `${dateFormat(fromDate, "dd/mm/yyyy")} - ${dateFormat(toDate, "dd/mm/yyyy")}`;
      case "year":
        return `${dateFormat(fromDate, "dd/mm/yyyy")} - ${dateFormat(toDate, "dd/mm/yyyy")}`;
      case "custom":
        return `${dateFormat(fromDate, "dd/mm/yyyy ")} - ${dateFormat(toDate, "dd/mm/yyyy ")}`;
      default:
        return '';
    }
  }

  const getFormattedFromAndToDate = (interval) => {
    let formattedDate = ''
    switch (interval) {
      case 'day':
        formattedDate = `Date: ${dateFormat(
          filters.fromDate,
          "dd/mm/yyyy "
        )}`
        break;
      case "week":
        const fromDateMinusOneDay = new Date(filters.fromDate);
        fromDateMinusOneDay.setDate(fromDateMinusOneDay.getDate() - 1);
        formattedDate = `Date: ${dateFormat(fromDateMinusOneDay, "dd/mm/yyyy ")} 
          to ${dateFormat(filters.toDate, "dd/mm/yyyy ")}`;
      case "month":
      case "year":
        formattedDate = `Date: ${dateFormat(filters.fromDate, "dd/mm/yyyy ")} 
          to ${dateFormat(filters.toDate, "dd/mm/yyyy ")}`
        break;
      case "custom":
        formattedDate = `Date: ${dateFormat(filters.fromDate, "dd/mm/yyyy hh:MM TT ")} 
          to ${dateFormat(filters.toDate, "dd/mm/yyyy hh:MM TT")}`
        break;
      default:
        formattedDate = ''
    }

    setFormattedDate(formattedDate);

  }
  useEffect(() => {
    const container = document.getElementsByClassName("filetrs-container")[0];
    if (container) {
      if (container.scrollWidth > container.clientWidth) {
        setIsScrollable(true);
      } else {
        setIsScrollable(false);
      }
    }
  }, [appliedFilters]);

  useEffect(() => {
    setChipInputSize(getChipInputSize(screenWidth));
    return () => {
      setSearchState("");
    };
  }, [screenWidth]);


  useEffect(() => {
    setTempFilters(() => filters);
    let selectedServices = filters?.services?.map((ser) => ({
      name: ser,
      type: "service"
    }))

    let selectedStatus = filters?.statuses?.map((st) => ({
      name: st,
      type: "status",
    }));

    let selectedStates = filters?.states?.map((state) => ({
      name: state,
      type: "state",
    }));

    let selectedLocations = isHideDSPFilter
      ? []
      : (filters?.dsps ?? []).map((dspId) => {
        const dsp = dsps?.find((dsp) => dsp?.dsp_id === dspId);
        return { name: dsp?.dsp_name, type: "dsp" };
      });

    const filtersToBeShown = [...selectedStatus, ...selectedLocations, ...selectedStates];

    getFormattedFromAndToDate(filters?.interval);

    if (filters.paymentMethods && filters.paymentMethods.length === 1) {
      filtersToBeShown.push({
        name:
          filters.paymentMethods[0] === PAYMENT_METHODS.OFFLINE
            ? "Cash"
            : filters.paymentMethods[0],
        type: `paymentMethods`,
      });
    }
    if (filters.onlyAppliedBhuMeetCouponsRequests) {
      filtersToBeShown.push({
        name: `Coupons Applied Requests (BhuMeet)`,
        type: `onlyAppliedBhuMeetCouponsRequests`,
      });
    }

    if (filters.interval && filters.interval !== "all" && filters.fromDate && filters.toDate) {
      const dateLabel = getDateLabelfromFromDateAndToDate(
        filters.interval,
        filters.fromDate,
        filters.toDate
      );
      filtersToBeShown.push({
        name: dateLabel,
        type: "date",
      });
    }

    setAppliedFilters(filtersToBeShown);
  }, [filters, dsps]);

  const getChipInputSize = (screenSize) => {
    if (isFromUserDetails) {
      switch (screenSize) {
        case "x-large":
          return 6;
        case "large":
          return 5;
        case "medium":
          return 3;
        case "small":
          return 2;
        default:
          return 6;
      }
    } else {
      switch (screenSize) {
        case "x-large":
          return 6;
        case "large":
          return 4;
        case "medium":
          return 3;
        case "small":
          return 2;
        default:
          return 6;
      }
    }
  };

  useEffect(() => {
    getDspsFunc();
  }, []);

  console.log("dsps",dsps);

  return (
    <>
      <div className="flex flex-col gap-1">
        <div className="w-[100%] max-w-[100%] flex justify-between items-center mb-[8px]">
          <div className="flex items-center gap-8 md:gap-12 ">
            <div className="date-range-Filters">
              <DurationFilters
                options={durationOptions}
                interval={filters.interval}
                handleFilterChanged={(filters) => {
                  let updatedfilters = { ...filters, pageNumber: 1 };
                  if (filters.interval === "all") {
                    updatedfilters = {
                      ...updatedfilters, orderBy: "time",
                      orderType: "DESC",
                    }
                  }
                  onFilterChange(updatedfilters)
                }}
                isAdmin={true}
              />
            </div>
          </div>
          <div>
            <Modal
              header={"Filter"}
              contentStyle={{ width: "950px", height: "600px" }}
              headingStyle={{ fontSize: "18px", fontWeight: 600 }}
              headerContainerStyle={{ padding: "20px" }}
              open={open}
              onClose={() => {
                setTempFilters(filters);
                setSearchState("");
                setSearchDsp("");
                onClose();
              }}
            >
              <div
                style={{ width: "100%", borderTop: "0.5px solid lightgray" }}
              ></div>
              {loading ? (
                <LoaderComponent />
              ) : (
                <div
                  style={{
                    fontSize: GLOBAL_STYLES.FONT_SIZE_REGULAR,
                    height: "calc(100% - 120px)",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      padding: "18px 32px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      gap: "10%",
                    }}
                  >
                    <DateTimePicker
                      title="From"
                      selectedDateTime={tempFilters.fromDate}
                      minTime={new Date().setHours(0, 0)}
                      maxTime={new Date().setHours(23, 59)}
                      onChange={(date) => {
                        setTempFilters({
                          ...tempFilters,
                          fromDate: date,
                          interval: "custom"
                        });
                      }}
                    />
                    <DateTimePicker
                      title="To"
                      hidePrev={tempFilters.fromDate}
                      selectedDateTime={tempFilters.toDate}
                      minTime={
                        new Date(tempFilters?.fromDate).toDateString() ===
                          new Date(tempFilters?.toDate).toDateString()
                          ? new Date(
                            new Date(tempFilters.fromDate).setMinutes(
                              new Date(tempFilters.fromDate).getMinutes() + 1
                            )
                          )
                          : new Date().setHours(0, 0, 0, 0)
                      }
                      maxTime={new Date().setHours(23, 59)}
                      onChange={(date) => {
                        setTempFilters({
                          ...tempFilters,
                          toDate: !tempFilters.toDate
                            ? new Date(date).setHours(23, 59)
                            : new Date(date),
                          interval: "custom"
                        });
                      }}
                      isDisable={!tempFilters.fromDate}
                    />
                  </div>
                  {activeTab !== "LEAD" && (
                  <PaymentMethodRadioButtons
                    onChangePaymentMethods={(pm) =>
                      setTempFilters({ ...tempFilters, paymentMethods: pm })
                    }
                    activePaymentMethods={tempFilters.paymentMethods}
                    isDisabled={
                      !(
                        tempFilters?.statuses &&
                        tempFilters.statuses.length === 1 &&
                        tempFilters.statuses[0] === PAYMENT_STATUSES.PAID
                      )
                    }
                  />
                  )}
                  <div
                    style={{
                      padding: "5px 30px",
                      display: "grid",
                      gridTemplateColumns: "1.2fr 1fr 1.2fr 1.5fr",
                      height: "65%",
                      rowGap: "10px",
                      fontSize: "14px",
                      columnGap: "10px",
                    }}
                  >
                    {activeTab !== "LEAD" && (
                    <>
                    <div style={{ fontSize: "16px", fontWeight: 500, display: "flex", alignItems: "center" }}>
                      <span>DSPs</span>
                      <input
                        style={{ width: "150px", margin: "0 2px 0 4%", borderRadius: "3px", border: "1px solid #d9d9d9", color: "#3B3B3B", fontSize: "12px", padding: "1.5px 5px" }}
                        type="text"
                        placeholder="Search dsp here..."
                        onChange={(e) => {
                          e.preventDefault();
                          setSearchDsp(e.target.value)
                        }} />
                    </div>
                    <div style={{ fontSize: "16px", fontWeight: 500 }}>
                      Status
                    </div>
                    <div style={{ fontSize: "16px", fontWeight: 500, display: "flex" }}>
                      States <input
                        style={{ width: "100%", margin: "0 2px 0 4%", borderRadius: "3px", border: "1px solid #d9d9d9", color: "#3B3B3B", fontSize: "12px", padding: "0px 0px 0px 5px" }}
                        type="text"
                        placeholder="Search state here..."
                        onChange={(e) => {
                          e.preventDefault();
                          setSearchState(e.target.value)
                        }} />
                    </div>
                    </>
                    )}
                    <div style={{ fontSize: "16px", fontWeight: 500 }}>
                      Other Settings
                    </div>
                    {/* <div style={{ fontSize: "16px", fontSize: '14px', display: "flex", flexDirection: "column", rowGap: "23px", height: "100%", color: "#3B3B3B", fontWeight: 500, maxHeight: "240px" }}>
                                {Object.keys(AEROMEGH_SERVICES).slice(0, 2).map((key) => {
                                    return <SingleFilter
                                        isChecked={tempFilters.services.filter(status => status == AEROMEGH_SERVICES[key]).length > 0}
                                        onChange={handleOnChangeServices}
                                        value={AEROMEGH_SERVICES[key]}
                                        title={AEROMEGH_SERVICES[key].split(' ')[0]}
                                    />
                                })}
                            </div> */}
                    {activeTab !== "LEAD" && (
                    <>
                    <div
                      style={{
                        fontSize: "14px",
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "8px",
                        overflowY: "auto",
                        height: "100%",
                        color: "#3B3B3B",
                        fontWeight: 500,
                        maxHeight: "240px",
                      }}
                    >
                      {(searchDsp ? dsps.filter(d =>
                      (d.dsp_name ?? '').toLowerCase().includes((searchDsp ?? '').toLowerCase())
                    ) : dsps
                  )?.map((dsp) =>
                    dsp.dsp_is_active && dsp.dsp_name?.trim() && ( // only render when name is non-empty after trim
                          <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                              }}
                            >
                              <div
                                style={{
                                  width: "25px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <input
                                  disabled={isHideDSPFilter}
                                  checked={
                                    tempFilters?.dsps?.filter(
                                      (loc) => loc === dsp.dsp_id
                                    ).length > 0
                                  }
                                  onChange={handleOnChangeLocation}
                                  value={dsp.dsp_id}
                                  type={"checkbox"}
                                  className="input-checkbox"
                                  style={{ width: "16px" }}
                                />
                              </div>
                              <Tippy content={dsp.dsp_name}>
                                <span
                                  style={{
                                    lineHeight: 1.1,
                                    fontSize: "15px",
                                    fontWeight: 500,
                                  }}
                                >
                                  {reduceLongName(dsp.dsp_name, 40)}
                                </span>
                              </Tippy>
                            </div>
  )
)}
                    </div>
                    <div
                      style={{
                        fontSize: "14px",
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "8px",
                        color: "#3B3B3B",
                        fontWeight: 500,
                        maxHeight: "240px",
                        overflowY: "auto",
                      }}
                    >
                      {Object.keys(STATUS).map((key) => {
                        return (
                          <SingleFilter
                            isChecked={
                              tempFilters?.statuses?.filter(
                                (status) => status == STATUS[key]
                              ).length > 0
                            }
                            onChange={handleOnChangeStatus}
                            value={STATUS[key]}
                            title={STATUS[key]}
                          />
                        );
                      })}
                    </div>
                    <div
                      style={{
                        fontSize: "14px",
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "8px",
                        color: "#3B3B3B",
                        fontWeight: 500,
                        maxHeight: "240px",
                        overflowY: "auto",
                      }}
                    >
                      {(searchState ? INDIAN_STATES.filter(s => s.toLowerCase().includes(searchState.toLowerCase())) : INDIAN_STATES).map((key) => {
                        return (
                          <SingleFilter
                            isChecked={tempFilters?.states?.includes(key)}
                            onChange={handleOnChangeState}
                            value={key}
                            title={key}
                          />
                        );
                      })}
                    </div>
                    </>
                    )}
                    <div
                      style={{
                        display: "inline-flex",
                        rowGap: "8px",
                        flexDirection: "column",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "left",
                          alignItems: "center",
                        }}
                      >
                        <input
                          style={{ margin: "0 10px", width: "16px" }}
                          checked={tempFilters?.isFilterByServiceTime}
                          disabled={
                            !(tempFilters?.fromDate && tempFilters?.toDate)
                          }
                          onChange={(e) =>
                            setTempFilters({
                              ...tempFilters,
                              isFilterByDateCreated: false,
                              isFilterByServiceTime: e.target.checked,
                              orderBy: e.target.checked ? 'time' : tempFilters.orderBy,
                              statuses: e.target.checked
                                ? []
                                : tempFilters.statuses,
                              paymentMethods: e.target.checked
                                ? null
                                : tempFilters.paymentMethods,
                            })
                          }
                          value={tempFilters?.isFilterByServiceTime}
                          type={"checkbox"}
                          className="input-checkbox"
                        />
                        <div
                          style={{
                            color: "#3B3B3B",
                            fontSize: "15px",
                            fontWeight: 500,
                          }}
                        >
                          Filter by scheduled date
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "left",
                          alignItems: "center",
                        }}
                      >
                        <input
                          style={{ margin: "0 10px", width: "16px" }}
                          checked={tempFilters?.isFilterByDateCreated}
                          disabled={
                            !(tempFilters?.fromDate && tempFilters?.toDate)
                          }
                          onChange={(e) =>
                            setTempFilters({
                              ...tempFilters,
                              isFilterByServiceTime: false,
                              isFilterByDateCreated: e.target.checked,
                              orderBy: e.target.value ? "date_created" : tempFilters.orderBy
                            })
                          }
                          value={tempFilters?.isFilterByDateCreated}
                          type={"checkbox"}
                          className="input-checkbox"
                        />
                        <div
                          style={{
                            color: "#3B3B3B",
                            fontSize: "15px",
                            fontWeight: 500,
                          }}
                        >
                          Filter by Date created
                        </div>
                      </div>
                      {activeTab !== "LEAD" && (
                      <IsBhuMeetCouponApplied
                        onlyAppliedBhuMeetCouponsRequests={
                          tempFilters.onlyAppliedBhuMeetCouponsRequests
                        }
                        onChangeOnlyAppliedBhuMeetCouponsRequests={(value) =>
                          setTempFilters({
                            ...tempFilters,
                            onlyAppliedBhuMeetCouponsRequests: value,
                          })
                        }
                      />
                      )}
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "20px 30px",
                      borderTop: "0.5px solid #BFC8D9",
                    }}
                  >
                    <div
                      onClick={async () => {
                        if (isHideDSPFilter) {
                          setTempFilters({
                            ...filters,
                            services: [],
                            statuses: [],
                            fromDate: null,
                            toDate: null,
                            paymentMethods: null,
                            onlyAppliedBhuMeetCouponsRequests: false,
                            isFilterByServiceTime: false,
                            interval: "all",
                          });
                        } else {
                          setTempFilters({
                            dsps: [],
                            services: [],
                            statuses: [],
                            states: [],
                            fromDate: null,
                            toDate: null,
                            paymentMethods: null,
                            onlyAppliedBhuMeetCouponsRequests: false,
                            isFilterByServiceTime: false,
                            interval: "all",
                          });
                        }
                      }}
                      style={{
                        width: "100px",
                        color: GLOBAL_STYLES.BG_ACTIVE,
                        fontWeight: 600,
                        fontSize: "14px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                      }}
                    >
                      Clear all
                    </div>
                    <Button
                      text={"Apply"}
                      style={{
                        width: "130px",
                        height: "38px",
                        fontSize: "15px",
                        marginRight: "10px",
                      }}
                      onClick={async () => {
                        let updatedFilters = { ...tempFilters }
                        onFilterChange(updatedFilters);
                        setSearchState("");
                        setSearchDsp("");
                        onClose();
                      }}
                    />
                  </div>
                </div>
              )}
            </Modal>
            <div style={{ display: "flex ", justifyContent: "flex-end", gap: "1.8rem", alignItems: "center" }}>
              {filters.fromDate && filters.toDate
                ?
                <div className="flex flex-col  ">
                  <div className="flex rounded-tl-[8px] rounded-bl-[8px] rounded-br-[8px] bg-[#FFFFFF] rounded-tr-[8px] border border-gray-300 min-w-[320px] ">
                    <button
                      disabled={false}
                      type="button"
                      className={`flex-1 px-4 py-[5px]  text-[#1E1E1E] whitespace-nowrap text-sm border-[1px] border-r-[#9BA6BE] rounded-tl-[8px] rounded-bl-[8px] transition-colors w-1/3 ${filters.isFilterByDateCreated
                        ? 'bg-[#D8E5FF] '
                        : 'bg-transparent text-gray-700 hover:bg-gray-100'
                        }`}
                      onClick={() => {
                        onFilterChange({ ...filters, isFilterByDateCreated: true, isFilterByServiceTime: false, orderBy: "date_created" })
                      }}
                    >
                      Created
                    </button>
                    <button
                      disabled={false}
                      type="button"
                      className={`flex-1 px-4 py-[5px] text-[#1E1E1E] border-[1px] border-r-[#9BA6BE] whitespace-nowrap text-sm  transition-colors w-1/2 ${filters.isFilterByServiceTime
                        ? 'bg-[#D8E5FF] '
                        : 'bg-transparent text-gray-700 hover:bg-gray-100'
                        }`}
                      onClick={() => {
                        onFilterChange({ ...filters, statuses: [], isFilterByServiceTime: true, isFilterByDateCreated: false, orderBy: 'time' })
                      }}
                    >
                      Scheduled
                    </button>
                    {activeTab !== "LEAD" && (
                    <button
                      disabled={false}
                      type="button"
                      className={`flex-1 px-4 py-[5px] text-[#1E1E1E] rounded-br-[8px] rounded-tr-[8px] whitespace-nowrap text-sm  transition-colors w-1/2 ${(!filters.isFilterByDateCreated && !filters.isFilterByServiceTime)
                        ? 'bg-[#D8E5FF] border '
                        : 'bg-transparent text-gray-700 hover:bg-gray-100'
                        }`}
                      onClick={() => {
                        onFilterChange({ ...filters, isFilterByDateCreated: false, isFilterByServiceTime: false, orderBy: "last_updated" })
                      }}
                    >
                      Last updated
                    </button>
                    )}
                  </div>
                </div>
                : null
              }
              {
                <Button
                  innerClassName={"filter-btn-inner"}
                  iconStyle={{ width: "15px", marginRight: "5px" }}
                  text={"Add Filter"}
                  icon={filterIcon}
                  className={"orders_filter_button "}
                  onClick={() => {
                    setOpenFilter(true);
                  }}
                  textClassName={"user-details-filter-text font-manrope font-[500]"}
                />
              }
            </div>
          </div>
        </div>
        <div className={`flex justify-end gap-3 mr-1 w-[100%] ${filters.fromDate && filters.toDate && (filters.isFilterByDateCreated || filters.isFilterByServiceTime) ? '' : 'pt-[10px]'}  pb-[3px]`}>
          <div className="admin_request_chip_input">

            <div
              className="filetrs-container"
              style={{
                display: "flex",
                gap: "10px",
                flexWrap: "wrap",
                maxWidth: "100%",
                overflow: "auto",
                width: "100%",
              }}
            >
              {appliedFilters?.length > 0 &&
                appliedFilters.map((filter) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        fontSize: "13px",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "8px",
                        color: "#1E1E1E",
                        background: "#FFFFFF",
                        border: "1px solid #3B3B3B",
                        height: "32px",
                        width: "110px",
                        minWidth: "fit-content",
                        borderRadius: "15px",
                        padding: "10px 8px",
                      }}
                    >
                      <Tippy
                        allowHTML={true}
                        content={
                          <CustomTooltip
                            content={filter.name}
                            customStyle={{ maxWidth: "230px" }}
                          />
                        }
                        placement="top-start"
                      >
                        <span className="font-manrope font-[600]">
                          {filter.name?.length > 25
                            ? reduceLongName(filter.name, 25)
                            : filter.name}
                        </span>
                      </Tippy>
                      <img
                        className="cursor-pointer mt-[2px]"
                        onClick={() => clearFilter(filter)}
                        src={CloseIcon}
                        width={15}
                        alt="closebtn"
                      />
                    </div>
                  );
                })}
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default AdminFilterRequest;
